import { NgModule, DoBootstrap } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { setAngularJSGlobal, UpgradeModule } from '@angular/upgrade/static';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import angular from 'angular';
import { AJSCurrencyServiceProvider, commonsTranslateLoader, rootScopeProvider } from 'ib-web-commons/utils';
import { AJSCheckinModalServiceProvider } from './app/shared/services/ib-modal/ib-checkin-modal-service-bridge.service';
import { CheckinAppConstants } from './components/routing/ib-check-in-constants';
import { IbCPipeModule } from 'ib-web-commons/pipes';
import { IbCModalModule } from 'ib-web-commons/ib-modal';
import { IbCDirectivesModule } from 'ib-web-commons/directives';
import { DatalayerUtilsProvider, IbCDatalayerUtilsService } from 'ib-web-commons/ib-datalayer';
import { IbCommonGenericInterceptorProvider } from 'ib-web-commons/interceptor';
import { IbMenusAppModule } from 'ib-menus';
import { IbCheckinAppRoutingModule } from './ib-checkin-app-routing.module';
import { AppComponent } from './app.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IbCheckinPaymentsModule } from './app/pages/ib-checkin-payments/ib-checkin-payments.module';
import { NgReactModule } from './app/react/wrapper/ng-react.module';
import { AJSCommonsHttpUtilServiceProvider } from './app/shared/services/ib-utils/ib-check-in-http-utils.service';
import { AJSCommonsGenericProxyProvider } from './app/shared/services/ib-proxy/commons-proxy-bridge.service';
import { AJSNewMainHeaderFacadeProvider } from './app/shared/services/ib-header/ib-NewMainHeaderFacade-bridge.service';
import { AJSLocationProvider } from './app/shared/services/ib-utils/ib-checkin-redirection.service';
import { AJSDigitalDataServiceProvider } from './app/shared/services/ib-datalayer/services/ib-cki-digital-data-service-bridge.service';
import { AJSDatalayerUtilsServiceProvider } from './app/shared/services/ib-datalayer/services/ib-cki-datalayer-utils-service-bridge.service';
import { AJSDatalayerServiceProvider } from './app/shared/services/ib-datalayer/services/ib-cki-datalayer-service-bridge.service';
import { AJSUpdateFlightsPassengerInfoServiceProvider } from './app/shared/services/ib-apis/ib-update-flights_passenger-info-service-bridge.service';
import { AJSApisFormServiceProvider } from './app/shared/services/ib-apis/ib-apis-form-service-bridge.service';
import { AJSGetPhoneCodesServiceProvider } from './app/shared/services/ib-apis/ib-get-phone-codes-service-bridge.service';
import { AJSTravelInfoServiceProvider } from './app/shared/services/ib-apis/ib-travel-info-service-bridge.service';
import { AJSPassengerAdditionalInfoServiceProvider } from './app/shared/services/ib-apis/ib-passenger-additional-info-service-bridge.service';
import { AJSNewslettersServiceProvider } from './app/shared/services/ib-apis/ib-newsletters-service-bridge.service';
import { AJSGetStatesListServiceProvider } from './app/shared/services/ib-apis/ib-get-states-list-service-bridge.service';
import { AJSGetFrequentFlyersServiceProvider } from './app/shared/services/ib-apis/ib-get-frequent-flyers-service-bridge.service';
import { AJSGetCountriesListServiceProvider } from './app/shared/services/ib-apis/ib-get-countries-list-service-bridge.service';
import { AJSGetCKICachedInformationServiceProvider } from './app/shared/services/ib-apis/ib-get-cached-information-service-bridge.service';
import { AJSCallApisFormServiceProvider } from './app/shared/services/ib-apis/ib-call-apis-form-service-bridge.service';
import { AJSModalServiceProvider } from './app/shared/services/ib-modal/ib-modal-service-bridge.service';
import { IbAncillariesAppModule } from 'ib-web-ancillaries';
import { IbCheckinApisModule } from './app/pages/ib-checkin-apis/ib-checkin-apis.module';
import { IbCheckinSharedModule } from './app/shared/ib-checkin-shared.module';

export function createTranslateLoader (http: HttpClient) {
    return commonsTranslateLoader(http, [CheckinAppConstants.i18nRoute, CheckinAppConstants.generalI18nRoute]);
}
setAngularJSGlobal(angular);

// Fixes ivy aot compilation: https://github.com/angular/angular/issues/37102
const downgradedCKIComponents = [];

@NgModule({
    declarations: [AppComponent, ...downgradedCKIComponents],
    imports: [
        BrowserModule,
        UpgradeModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            },
            defaultLanguage: 'es'
        }),
        IbCPipeModule,
        IbCModalModule,
        IbCDirectivesModule,
        IbMenusAppModule,
        IbCheckinAppRoutingModule,
        ReactiveFormsModule,
        NgReactModule,
        IbCheckinPaymentsModule,
        IbAncillariesAppModule,
        IbCheckinApisModule,
        IbCheckinSharedModule
    ],
    providers: [
        AJSUpdateFlightsPassengerInfoServiceProvider,
        AJSDatalayerServiceProvider,
        AJSDigitalDataServiceProvider,
        AJSDatalayerUtilsServiceProvider,
        AJSApisFormServiceProvider,
        AJSGetPhoneCodesServiceProvider,
        AJSTravelInfoServiceProvider,
        AJSPassengerAdditionalInfoServiceProvider,
        AJSNewslettersServiceProvider,
        AJSGetStatesListServiceProvider,
        AJSGetFrequentFlyersServiceProvider,
        AJSGetCountriesListServiceProvider,
        AJSGetCKICachedInformationServiceProvider,
        AJSCallApisFormServiceProvider,
        AJSModalServiceProvider,
        AJSDigitalDataServiceProvider,
        AJSDatalayerUtilsServiceProvider,
        AJSDatalayerServiceProvider,
        AJSLocationProvider,
        AJSNewMainHeaderFacadeProvider,
        AJSCurrencyServiceProvider,
        AJSCommonsGenericProxyProvider,
        rootScopeProvider,
        DatalayerUtilsProvider,
        ...IbCommonGenericInterceptorProvider,
        IbCDatalayerUtilsService,
        AJSCheckinModalServiceProvider,
        AJSCommonsHttpUtilServiceProvider
    ],
    bootstrap: [AppComponent],
    exports: [NgReactModule]
})
export class IbCheckinAppModule {
    static downgradedComponent = [...downgradedCKIComponents];
}
